export const SET_USER = 'BASIC_INFO/SET_USER';
export const SET_USER_ID = 'BASIC_INFO/SET_USER_ID';
export const SET_USER_RESALE_ID = 'BASIC_INFO/SET_USER_RESALE_ID';
export const SET_RECAPTCHA = 'BASIC_INFO/SET_RECAPTCHA';
export const CLEAR_PASSWORD = 'BASIC_INFO/CLEAR_PASSWORD';
export const CLEAR_BASIC_INFORMATION = 'BASIC_INFO/CLEAR_BASIC_INFORMATION';
export const HANDLE_LOADING = 'BASIC_INFO/HANDLE_LOADING';
export const SET_USER_RESTRICTIONS = 'BASIC_INFO/SET_USER_RESTRICTIONS';